// extracted by mini-css-extract-plugin
module.exports = {"top":"Detail_top_h_ZKV","img":"Detail_img_e_5DA","contents":"Detail_contents_1hJKj","table":"Detail_table_cCDtW","cars":"Detail_cars_1WYlv"};